<template>
  <div class="modal fade" @keyup.esc.prevent="closeModal(false)" tabindex="-1" id="ticketGrantModal" aria-labelledby="ticketGrantModalLabel">
    <div class="modal-dialog modal-lg">
      <div v-if="loaded" class="modal-content shadow-none">
        <loader />
      </div>
      <div v-else class="modal-content shadow-none">
        <div class="modal-header p-5">
          <h5 class="modal-title">Начислить абонемент</h5>
          <div @click="closeModal(false)" class="btn btn-icon btn-sm btn-active-light-primary ms-2">
            <i class="ki-duotone ki-cross fs-2x"><span class="path1"></span><span class="path2"></span></i>
          </div>
        </div>
        <div class="modal-body p-5">
          <div v-if="tickets && tickets.length" class="custom-select dynamic w-100 mb-5">
            <label for="form.specId" class="required">Абонемент (spec)</label>
            <v-select
              v-model="form.specId"
              input-id="form.specId"
              :options="tickets"
              :disabled="!tickets.length"
              :reduce="item => item.id"
              :required="true"
              placeholder="Выберите..."
              class="bg-gray-100 form rounded"
              label="code"
            />
          </div>
          <div class="row">
            <div class="col-9">
              <input-field
                v-model="userId"
                id="userId"
                name="userId"
                placeholder="Пользователь ID (через запятую)"
                type="text"
                mb="5"
              />
            </div>
            <div class="col-3">
              <button type="button" class="btn btn-light-warning h-50px w-100" @click="addUserId">Добавить</button>
            </div>
          </div>
          <div v-if="form.userIds && form.userIds.length" class="d-flex flex-wrap gap-2 mt-2">
            <div
              v-for="(id, idx) in form.userIds"
              :key="`${id}-${idx}`"
              class="d-inline-flex align-items-center rounded px-3 py-2 bg-light-secondary"
            >
              <span class="me-2">{{ id }}</span>
              <button
                type="button"
                class="btn btn-icon btn-sm btn-active-light-danger"
                aria-label="Удалить"
                @click="removeUserId(idx)"
              >
                <i class="ki-duotone ki-cross fs-5"><span class="path1"></span><span class="path2"></span></i>
              </button>
            </div>
          </div>
        </div>
        <div class="modal-footer p-5 justify-content-between">
          <button type="button" @click="closeModal(false)" class="btn btn-light btn-sm">Закрыть</button>
          <button  
              type="button" 
              @click="setGrant" 
              :disabled="saving"
              class="btn btn-primary btn-sm"
            >
              {{ saving ? 'Начисление...' : 'Начислить' }}
            </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import InputField from '@/components/Fields/InputField'
import CurrencyField from '@/components/Fields/CurrencyField'
import SwitchBoxField from '@/components/Fields/SwitchBoxField'
import vSelect from 'vue-select'
import { notify } from '@kyvg/vue3-notification'
import axios from 'axios'

export default {
  name: 'TicketGrantModal',
  components: { Loader, InputField, CurrencyField, SwitchBoxField, vSelect },
  data() {
    return {
      loaded: false,
      saving: false,
      form: {
        specId: null,
        userIds: [],
      },
      tickets: null,
      userId: null,
    }
  },
  mounted() {
    this.fetchTickets()
    setTimeout(() => {
      const modal = document.getElementById('ticketGrantModal')
      if (modal) {
        modal.addEventListener('mousedown', (event) => {
          if (event.target.classList.contains('modal')) this.closeModal()
        })
      }
    }, 10)
  },
  methods: {
    closeModal() {
      bootstrap.Modal.getInstance(document.getElementById('ticketGrantModal')).hide();
      this.$emit('closeModal', true);
    },
    resetForm() {
      this.form = {
        specId: null,
        userIds: [],
      }
      this.userId = null
    },
    addUserId() {
      const raw = (this.userId ?? '').toString().trim()
      if (!raw) {
        notify({ duration: 4000, type: 'warn', speed: 800, title: 'Внимание', text: 'Введите пользователь ID' })
        return
      }

      const ids = raw
        .split(',')
        .map((x) => x.trim())
        .filter(Boolean)
        .map((x) => (/^\d+$/.test(x) ? Number(x) : x))

      if (!ids.length) {
        notify({ duration: 4000, type: 'warn', speed: 800, title: 'Внимание', text: 'Введите пользователь ID' })
        return
      }

      const uniqueIds = ids.filter((value, index) => ids.indexOf(value) === index)
      const added = uniqueIds.filter((value) => !this.form.userIds.includes(value))

      if (!added.length) {
        notify({ duration: 4000, type: 'warn', speed: 800, title: 'Внимание', text: 'Эти ID уже добавлены' })
        return
      }

      this.form.userIds.push(...added)
      this.userId = null
    },
    removeUserId(idx) {
      if (!Array.isArray(this.form.userIds)) return
      this.form.userIds.splice(idx, 1)
    },
    fetchTickets() {
      axios.get('/api/v1/billing/issuer/tickets/specs?page=0&size=200')
        .then(res => {
          this.tickets = res.data?.content || []
        })
        .catch(err => {
          notify({ duration: 7000, type: 'error', speed: 1000, title: 'Ошибка', text: err?.response?.data?.errorDescription ?? err.message })
        })
    },
    setGrant() {
      if (!this.form.specId) {
        notify({ duration: 4000, type: 'warn', speed: 800, title: 'Внимание', text: 'Выберите абонемент (spec)' })
        return
      }
      if (!Array.isArray(this.form.userIds) || this.form.userIds.length === 0) {
        notify({ duration: 4000, type: 'warn', speed: 800, title: 'Внимание', text: 'Добавьте хотя бы один пользователь ID' })
        return
      }

      this.saving = true
      axios.post('/api/v1/billing/issuer/tickets/grant', this.form)
        .then(() => {
          notify({ duration: 5000, type: 'success', speed: 1000, title: 'Успешно', text: 'Абонемент начислен' })
          this.resetForm()
          this.closeModal()
        })
        .catch(err => {
          notify({ duration: 7000, type: 'error', speed: 1000, title: 'Ошибка', text: err?.response?.data?.errorDescription ?? err.message })
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>

<style scoped>

</style>